export function UPIPayment() {
  return (
    <h2 style={{ textAlign: "center", marginTop: 50 }}>
      Scan QR / Pay via GPay, PhonePe or Paytm to complete your order 🔔
    </h2>
  );
}
